<template>
  <div>
    <Title
      :title-text="$t('interstitial_title_text')"
      :text="`${$t('interstitial_subtitle-text')}`"
      route="login"
      data-qa="por-interstitial--title" />
    <InterstitialForm data-qa="Interstitial-form" />
  </div>
</template>

<script>

import Title from '@/components/title'
import InterstitialForm from '@/components/forms/interstitial'
import { track } from '@/services/tracking'

export default {
  name: 'Login',
  components: {
    Title,
    InterstitialForm
  },
  mounted () {
    // Track page visit
    track({ name: 'page view', params: { module: 'interstitial' } })
  }
}
</script>
